module.exports = __webpack_public_path__ + "img/car.994c1d82.svg";